import React from 'react';
import Client from 'shopify-buy';

const client = Client.buildClient({
  domain: 'icloudready.myshopify.com',
  storefrontAccessToken: process.env.SHOPIFY_ACCESS_TOKEN
});

export const defaultStoreContext = {
  client,
  isCartOpen: false,
  isKitchenOpen: false,
  adding: false,
  checkout: { lineItems: [] },
  products: [],
  shop: {},
  addVariantToCart: () => {},
  addVariantToKitchen: () => {},
  removeLineItem: () => {},
  getRunResult: () => {},
  updateLineItem: () => {}
};

const StoreContext = React.createContext(defaultStoreContext);

export const withStoreContext = Component => {
  return props => (
    <StoreContext.Consumer>
      {context => <Component {...props} storeContext={context} />}
    </StoreContext.Consumer>
  );
};

export default StoreContext;
